var _path, _path2, _path3, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObjectifClimat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.896 59.874V6M62.896 59.874h-46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8062b",
    fillRule: "evenodd",
    d: "M23 11.957h13.451v46.937H23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#532fc5",
    fillRule: "evenodd",
    d: "M44.161 52h13.451v6.865H44.161z"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 24.149,
    y: 66.502,
    fontSize: 4,
    fontFamily: "sans-serif"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24.149,
    y: 66.502,
    style: {
      InkscapeFontSpecification: "Ubuntu"
    },
    fontWeight: 700,
    fontFamily: "Ubuntu"
  }, "2021")), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 4.413,
    y: 12.494,
    fontSize: 4,
    fontFamily: "sans-serif"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.413,
    y: 12.494,
    style: {
      InkscapeFontSpecification: "'Ubuntu Bold'"
    },
    fontWeight: 700,
    fontFamily: "Ubuntu"
  }, "10 t")), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 6.394,
    y: 51.335,
    fontSize: 4,
    fontFamily: "sans-serif"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.394,
    y: 51.335,
    style: {
      InkscapeFontSpecification: "'Ubuntu Bold'"
    },
    fontWeight: 700,
    fontFamily: "Ubuntu"
  }, "2 t")), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 45.937,
    y: 66.502,
    fontSize: 4,
    fontFamily: "sans-serif"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45.937,
    y: 66.502,
    style: {
      InkscapeFontSpecification: "'Ubuntu Bold'"
    },
    fontWeight: 700,
    fontFamily: "Ubuntu"
  }, "Vite !")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.757,
    cy: 9.576,
    r: 1,
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 10l20 40",
    fill: "none",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.375 50.787l-1.926-1.879 1.626-.704.3 2.583"
  }))));
}

export default SvgObjectifClimat;